import { Loading } from "portal/components/Loading";
import { postHog } from "portal/utils/postHog";
import { useAuth0 } from "@auth0/auth0-react";
import React, { FunctionComponent, useEffect } from "react";

export const Logout: FunctionComponent = () => {
  const auth0State = useAuth0();
  const { logout, isLoading, error } = auth0State;

  console.debug("Logout.tsx:render: auth0State:", auth0State);
  useEffect(() => {
    if (isLoading) {
      return;
    }
    // Drop the analytics identity so the next sign-in on this device is distinct.
    postHog.reset();
    logout();
  }, [isLoading, logout]);

  if (isLoading) {
    return <Loading failed={Boolean(error)} error={error} overlay />;
  }
};
